import { render, staticRenderFns } from "./MapeIntroduction.vue?vue&type=template&id=21a8434f&scoped=true"
import script from "./MapeIntroduction.vue?vue&type=script&lang=js"
export * from "./MapeIntroduction.vue?vue&type=script&lang=js"
import style0 from "./MapeIntroduction.vue?vue&type=style&index=0&id=21a8434f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8434f",
  null
  
)

export default component.exports